const ViewCategory = ({ comment, weekNumber }) => {
	const filteredData = comment.week_data.filter(
		// eslint-disable-next-line eqeqeq
		(item) => item.week_no == weekNumber
	);

	return (
		<td
			style={{
				backgroundColor:
					filteredData.length > 0 && filteredData[0].category
						? filteredData[0].category.color
						: "",
			}}
		>
			{filteredData.length > 0 && filteredData[0].category
				? filteredData[0].category.name
				: ""}
		</td>
	);
};

export default ViewCategory;
